var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgEye = function SvgEye(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.168 14.065c-1.11 0-2.012-.895-2.012-1.99 0-1.094.902-1.984 2.012-1.984 1.11 0 2.012.89 2.012 1.985 0 1.094-.903 1.989-2.012 1.989zm0-5.303c-1.85 0-3.354 1.487-3.354 3.314 0 1.826 1.504 3.313 3.354 3.313s3.354-1.487 3.354-3.313c0-1.827-1.505-3.314-3.354-3.314zm.16 8.178c-2.63.113-5.263-1.555-7.831-4.977.856-1.137 3.723-4.534 7.42-4.635 2.592-.054 5.156 1.5 7.598 4.668-.792 1.17-3.521 4.78-7.187 4.944zm8.543-5.366c-2.802-3.782-5.828-5.67-8.998-5.57-5.126.146-8.619 5.378-8.765 5.6a.661.661 0 00.017.747c2.838 3.933 5.842 5.922 8.936 5.922.11 0 .219-.004.328-.009 5.08-.23 8.382-5.729 8.52-5.963a.66.66 0 00-.038-.727z"
  })));
};

export default SvgEye;